import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationProfileHighlightedMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M16 17.825a6.825 6.825 0 100-13.65 6.825 6.825 0 000 13.65zm13.383 8.422l-1.234-2.32a8.852 8.852 0 00-7.833-4.7h-8.632a8.852 8.852 0 00-7.833 4.7l-1.234 2.32A3.826 3.826 0 006 31.871h20.01a3.826 3.826 0 003.378-5.624z"
        fill=""
      />
    </svg>
  )
);
SvgNavigationProfileHighlightedMedium.defaultProps = {
  color: "currentColor",
  size: 32,
  title: undefined,
  titleId: undefined,
};
SvgNavigationProfileHighlightedMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationProfileHighlightedMedium;
